import { addFilter } from '@situation/setdesign.util';

addFilter('content-slider/owl-settings', (settings, $el) => {
    const isSeating = $el && $el.hasClass('content-slider--seating');
    const isFadedBackground = $el && $el.hasClass('background-faded__slider');
    return {
        ...settings,
        items: 1,
        nav: true,
        navText: [
            '<svg><use xlink:href="#icon-long-arrow"></use></svg>',
            '<svg><use xlink:href="#icon-long-arrow"></use></svg>',
        ],
        ...(isSeating ? {} : { responsive: { 620: { margin: 20, items: 2 }, 1080: { margin: 40, items: 3 } } }),
        ...(isFadedBackground
            ? { responsive: { 0: { items: 1, margin: 0 } }, nav: false, animateOut: 'fadeOut' }
            : {}),
    };
});
